import { FullScreenPage, useFullScreenClose } from "@accurx/navigation";
import { BatchComposePage } from "domains/batch-messaging/pages/BatchComposePage/BatchComposePage";
import { BatchImportPatientListPage } from "domains/batch-messaging/pages/BatchImportPatientListPage/BatchImportPatientListPage";
import { BatchManualInputPage } from "domains/batch-messaging/pages/BatchManualInputPage/BatchManualInputPage";
import { BatchReviewPatientsPage } from "domains/batch-messaging/pages/BatchReviewPatientsPage/BatchReviewPatientsPage";
import { BatchSelectPage } from "domains/batch-messaging/pages/BatchSelectPage/BatchSelectPage";
import { BatchUploadFilePage } from "domains/batch-messaging/pages/BatchUploadFilePage/BatchUploadFilePage";
import { BATCH_MESSAGING_ROUTES } from "domains/batch-messaging/routes";
import { Switch } from "react-router-dom";

import { SimpleRoute } from "../../app/AppRoute";

export const UnifiedBatchRoutes = () => {
    const handleFullScreenClose = useFullScreenClose();

    return (
        <FullScreenPage
            header="New batch message"
            onClose={handleFullScreenClose}
        >
            <Switch>
                <SimpleRoute exact path={BATCH_MESSAGING_ROUTES.select}>
                    <BatchSelectPage />
                </SimpleRoute>
                <SimpleRoute exact path={BATCH_MESSAGING_ROUTES.fileUpload}>
                    <BatchUploadFilePage />
                </SimpleRoute>
                <SimpleRoute exact path={BATCH_MESSAGING_ROUTES.manualInput}>
                    <BatchManualInputPage />
                </SimpleRoute>
                <SimpleRoute
                    exact
                    path={BATCH_MESSAGING_ROUTES.importPatientList}
                >
                    <BatchImportPatientListPage />
                </SimpleRoute>
                <SimpleRoute
                    exact
                    path={BATCH_MESSAGING_ROUTES.demographicsReview}
                >
                    <BatchReviewPatientsPage />
                </SimpleRoute>
                <SimpleRoute exact path={BATCH_MESSAGING_ROUTES.compose}>
                    <BatchComposePage />
                </SimpleRoute>
            </Switch>
        </FullScreenPage>
    );
};
